// Range chunking for the Actual Mileage Report (FI-2171).
//
// The endpoint answers a week per request (MAX_DAYS in
// reports/tbn_actuals_mileage_report.py), because a fleet-wide odometer sweep plus the
// booking side of the report runs about 18s for a week against api gateway's 29s
// cutoff. A longer range is therefore fetched a week at a time.
import moment from 'moment'

export const DAYS_PER_REQUEST = 7
export const MAX_RANGE_DAYS = 31

const DAY_FORMAT = 'YYYY-MM-DD'

export function day_count(from_date, to_date) {
  return moment(to_date, DAY_FORMAT).diff(moment(from_date, DAY_FORMAT), 'days') + 1
}

// [['2026-09-01','2026-09-07'], ['2026-09-08','2026-09-10']]
export function chunk_range(from_date, to_date, days_per_request = DAYS_PER_REQUEST) {
  const total = day_count(from_date, to_date)
  const chunks = []
  for (let offset = 0; offset < total; offset += days_per_request) {
    const start = moment(from_date, DAY_FORMAT).add(offset, 'days')
    const days = Math.min(days_per_request, total - offset)
    chunks.push([start.format(DAY_FORMAT), start.clone().add(days - 1, 'days').format(DAY_FORMAT)])
  }
  return chunks
}

// A vehicle-day with nothing booked and no meaningful telematics movement: the bus sat
// in the yard. A range of 30 buses over a week is mostly these rows, so the report
// hides them unless asked. "no actuals" means no booking, no assignment, no driver and
// no calculated mileage; "no movement" means the mileage difference rounds to nothing.
export function is_idle_row(row, diff_threshold = 1) {
  if (!row) {
    return false
  }
  const has_actuals = !!(row.charterIDs || row.assignmentIDs || row.drivers ||
                         Number(row.actualTotalDistance || 0) > 0)
  if (has_actuals) {
    return false
  }
  return Math.abs(Number(row.diffTotalDistance || 0)) < diff_threshold
}
